import React,{useState,useEffect} from 'react';
import './spb.css';
import Top_selling_products from "./morenfts";
import ShareButton from "react-web-share-button";
import creatorimg from './image.jpg'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Fotter from '../../Home/Home_modules/Footerr/footer'
import WalletConnect from "@walletconnect/client";
import QRCodeModal from "@walletconnect/qrcode-modal";
import Web3 from 'web3'
import firebase from 'firebase/compat/app';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from 'axios';
import firebaseConfig, { db } from '../../fire';
import Count from "./Count.js"; 
import symphony from './symphony.png'
import avatar from './useravatar.png'
import { getAuth, getIdToken } from "firebase/auth";


const divStyle = {
    borderColor: '#ffffff',
    backgroundColor:'#ffffff',
  };

const walletAddress = localStorage.getItem("LAST_ACTIVE_ACCOUNT");

function SPBDrop(){
    
    require('dotenv').config()
   // console.log() 

    const [NFTData, setNFTData] = useState([]);
    const [bidHistory, setBidHistory] = useState([]);
    
    useEffect(() => {
        const spbnft = firebase.firestore().collection('NFTs').doc('fkUnfpB5zG2HhnvhmIcP');
        spbnft.get().then((doc) => {
            if (!doc.exists) return;
            //console.log("NFT data:", doc.data());
            setNFTData(doc.data());
        }).catch((error) => {
            //console.log("Error getting document:", error);
        });
        
        //bid history API
        localStorage.removeItem('chainId');
        localStorage.removeItem('walletconnect');
        const bidurl = "https://us-central1-diginoor-3755e.cloudfunctions.net/app/bid/latest";
        const bidData = new Array();
        fetch(bidurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                "nft": "fkUnfpB5zG2HhnvhmIcP"
            })
        }).then((response) => response.json())
            .then((responseJson) => {
                //console.log("Bid history:", responseJson);
                bidData.push(responseJson.response);
                setBidHistory(responseJson.response);
                //console.log("Bid history in array:", bidData);
                
            }).catch((error) => {
                //console.log("Error:", error);
            });
                }, [])
    //console.log(bidHistory)

    function loadingPopup(value){
        // console.log(value)
         if( value == true){
             document.querySelector('.spinner-over').classList.remove('completed')
             document.querySelector('.spinner-over').classList.add('half-spinner')
             document.querySelector('.spinner').classList.add('spinner-active')
         } else {
             document.querySelector('.spinner-over').classList.remove('half-spinner')
             document.querySelector('.spinner-over').classList.add('completed')
             setTimeout(() => {
                 document.querySelector('.spinner').classList.remove('spinner-active')
                 }, 5000);
         }
     }

    function checkWallet(){
        if (localStorage.getItem("LAST_ACTIVE_ACCOUNT") === null) {
            //alert("No Value")
            alert('Redirecting to Wallet Page...Please Connect Wallet to Proceed');
            const currentUrl = window.location.pathname;
            localStorage.setItem('currentUrl', currentUrl);
            window.location.href ="../../../Wallet/";
          } else {
            handlePopup();
          }
    }
    
    function checkBidValue(wallet){
        const bidValue = document.getElementById('updated_value').value;
        
        if (bidValue <= NFTData.NFTUpdatedPrice) {
            toast.error(`Please enter value greater than the last bid value. ${NFTData.NFTUpdatedPrice} ETH`,{position: toast.POSITION.TOP_CENTER})
        } else{
            placebid(wallet)
        }
        
     }
    
    const popupState = true;

    async function placebid(wallet) {
        const bidprice = document.getElementById('updated_value').value;
          const popupState = true;
          loadingPopup(popupState);
          const selectedWallet = wallet;
          //console.log(selectedWallet)
          //send payment
          
          if (selectedWallet === "metamask")
          {
              try
              {
                const web3 = new Web3(window.ethereum);
                const accounts = await web3.eth.getAccounts();
                const account = accounts[0];
                const ethereum = window.ethereum;
                await ethereum.request({ method: "eth_requestAccounts" });
                const chainId = await ethereum.request({ method: "eth_chainId" });
                    
                    try{
                        const { ethereum } = window;
                        // check mainnet or testnet
                        if (ethereum.networkVersion === "1") {
                            // mainnet
                           //console.log("Mainnet");
                           //console.log(ethereum.networkVersion)
                        }
                        else {
                            alert("Please switch to Mainnet to proceed");
                            const closeLoading = !popupState
                            loadingPopup(closeLoading);
                            return;
                        }
        
                        await ethereum.request({ method: "eth_requestAccounts" });
                        const accounts = await ethereum.request({ method: "eth_accounts" });
                        const chainId = await ethereum.request({ method: "eth_chainId" });
                        const price = web3.utils.toWei(bidprice, "ether");
                        try {
                            const bidResult = await window.ethereum.request({
                                method: "eth_sendTransaction",
                                params: [{
                                    from: accounts[0],
                                    to: "0xECe6f305aD9286d9adBaCfA49F564E04DF68be4A",
                                    value: web3.utils.toHex(price),
                                    data: "0x",
                                    gas: "0x30000",
                                    gasPrice: "2000000000",
                                    chainId: chainId
                                }]            
                            });
                            //console.log('Bidresult', bidResult);
                            //confirmEtherTransaction(bidResult);
                            toast.success("Transaction submitted to blockchain, Please wait...", {
                                position: "top-center", });
                            confirmEtherTransaction(bidResult);

                            } catch (error) {
                                toast.error("Payment Failed");
                                const closeLoading = !popupState
                                loadingPopup(closeLoading);
                            }
                        }
                        catch (error) {
                            //console.log(error);
                            toast.error("Please enable Metamask", {
                                position: "top-center", });
                            }
              }
                catch (error) {
                    toast.error("Please enable Metamask", {
                        position: "top-center", });
                    }
          }
            else if (selectedWallet === "walletconnect")
            {
                const connector = new WalletConnect({
                    bridge: "https://bridge.walletconnect.org", // Required
                    qrcodeModal: QRCodeModal,
                    });
                    if (!connector.connected) {
                        // create new session
                        connector.createSession();
                        connector.on("connect", (error, payload) => {
                          if (error) {
                            throw error;
                          }
                          // Get provided accounts and chainId
                          const { accounts, chainId } = payload.params[0];
                          //console.log(accounts);
                          localStorage.setItem('chainId', chainId);
                          const account = accounts[0];
                          localStorage.setItem('wc_account',account);
                          toast.success("Please click again to pay")
                          const closeLoading = !popupState
                                loadingPopup(closeLoading);
                        });  
                    }
                    else if (localStorage.getItem('chainId') === "1") {
                        
                        // send transaction
                        const account = localStorage.getItem('wc_account');
                        const price = Web3.utils.toWei(bidprice, "ether");
                        try {
                            const bidResult = await connector.sendTransaction({
                                from: account,
                                to: "0xECe6f305aD9286d9adBaCfA49F564E04DF68be4A",
                                value: Web3.utils.toHex(price),
                                data: "0x",
                                gas: "0x30000",
                                gasPrice: "2000000000",
                            });
                            //console.log('Bidresult', bidResult);
                            //confirmEtherTransaction(bidResult);
                            toast.success("Bid transaction submitted to blockchain, Please wait...", {
                                position: "top-center", });
                            confirmEtherTransaction(bidResult);
                            } catch (error) {
                                toast.error("Payment Failed");
                                const closeLoading = !popupState
                                loadingPopup(closeLoading);
                            }

                    }
                    else {
                        toast.error("Please switch to Mainnet to proceed", {
                            position: "top-center", });
                        const closeLoading = !popupState
                        loadingPopup(closeLoading);
                    }
                    
            }
            
            
            


    }

     {/*   async function placebid(wallet) {
          const bidprice = document.getElementById('updated_value').value;
            const popupState = true;
            loadingPopup(popupState);
            const selectedWallet = wallet;
            //console.log(selectedWallet)
            
            const bidapi ="https://api-us-west1.tatum.io/v3/blockchain/auction/bid";
            
            const bidapi_response = await fetch(bidapi, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': process.env.REACT_APP_TATUM_API_KEY,
                },
                body: JSON.stringify({
                    "chain": "ETH",
                    "contractAddress": "0x12afb15eaf523d82460B4C1427DFBa2E78D31867",
                    "id": "2",
                    "bidValue": bidprice,
                    "signatureId": "26d3883e-4e17-48b3-a0ee-09a3e484ac83"
                
                })
            });
            const bidapi_response_json = await bidapi_response.json();
            //console.log(bidapi_response_json);
            finalizebid(bidapi_response_json, selectedWallet);
             
        }
    
        async function finalizebid(bidapi_response_json, selectedWallet) {
            const { signatureId } = bidapi_response_json;
            const { data } = await axios.get('https://api-us-west1.tatum.io/v3/kms/' + signatureId, {
                                    headers: {
                                            'x-api-key': process.env.REACT_APP_TATUM_API_KEY
                                        }
                                    });
           const bidconfig = JSON.parse(data.serializedTransaction);
           //console.log(bidconfig);
           bidconfig.from = walletAddress;
           if( selectedWallet === "metamask"){
            try{
                const { ethereum } = window;
                // check mainnet or testnet
                if (ethereum.networkVersion === "1") {
                    // mainnet
                   //console.log("Mainnet");
                   //console.log(ethereum.networkVersion)
                }
                else {
                    alert("Please switch to Mainnet to proceed");
                    const closeLoading = !popupState
                    loadingPopup(closeLoading);
                    return;
                }

                await ethereum.request({ method: "eth_requestAccounts" });
                const accounts = await ethereum.request({ method: "eth_accounts" });
                const chainId = await ethereum.request({ method: "eth_chainId" });
                bidconfig.from = accounts[0];
                bidconfig.gasPrice = "2000000000";
                try {
                    const bidResult = await window.ethereum.request({
                        method: "eth_sendTransaction",
                        params: [bidconfig],
        
                    });
                    //console.log('Bidresult', bidResult);
                    confirmEtherTransaction(bidResult);
                    toast.success("Bid Placed successfully", {
                        position: "top-center", });
                    } catch (error) {
                        toast.error("Payment Failed");
                        const closeLoading = !popupState
                        loadingPopup(closeLoading);
                    }
                }
                catch (error) {
                    //console.log(error);
                    toast.error("Please enable Metamask", {
                        position: "top-center", });
                    }
                  } else if(selectedWallet === "walletconnect"){
                      const connector = new WalletConnect({
                          bridge: "https://bridge.walletconnect.org", // Required
                          qrcodeModal: QRCodeModal,
                          });
                          if (!connector.connected) {
                              // create new session
                              connector.createSession();
                              connector.on("connect", (error, payload) => {
                                if (error) {
                                  throw error;
                                }
                                // Get provided accounts and chainId
                                const { accounts, chainId } = payload.params[0];
                                //console.log(accounts);
                                const account = accounts[0];
                                localStorage.setItem('wc_account',account);
                                toast.success("Please click again to pay")
                              });  
                          }
                          else {
                              bidconfig.from = walletAddress;
                              connector.sendTransaction(bidconfig).then((bidResult) => {
                              // Returns transaction id (hash)
                              toast.success("Transaction submitted to the blockchain, Please wait")
                              //console.log(bidResult);
                              confirmEtherTransaction(bidResult);
                              // const file_id = localStorage.getItem('fileid') //getting the particular value from the local storage
                              //window.location.href ="../../../Nft_conformation/"+ file_id; //passing the value to the Confirmation Page
                            })
                            .catch((error) => {
                              // Error returned when rejected
                              toast.error("Transaction Rejected")
                              //console.error(error);
                            }); 
    
                          }
                          if (connector.connected){
                              bidconfig.from = localStorage.getItem('wc_account');
                              connector.sendTransaction(bidconfig).then((bidResult) => {
                              // Returns transaction id (hash)
                              toast.success("Transaction submitted to the blockchain, Please wait")
                              //console.log(bidResult);
                              confirmEtherTransaction(bidResult);
                              
                             // const file_id = localStorage.getItem('fileid') //getting the particular value from the local storage
                              //window.location.href ="../../../Nft_conformation/"+ file_id; //passing the value to the Confirmation Page
                            })
                            .catch((error) => {
                              // Error returned when rejected
                              toast.error("Transaction Rejected")
                              //console.error(error);
                            }); 
                              
                          }
                             
                          
                  }
              
            } */}

            async function getConfirmations(txHash) {
                try {
                  // Instantiate web3 with HttpProvider
                  const web3 = new Web3('https://mainnet.infura.io/v3/5b9cdbc4c85947dd90e13c0bd2f0c5a6')
                  
                  // Get transaction details
                  const trx = await web3.eth.getTransaction(txHash)
              
                  // Get current block number
                  const currentBlock = await web3.eth.getBlockNumber()
                  toast.success("waiting for atleast 2 confirmations")
                  // When transaction is unconfirmed, its block number is null.
                  // In this case we return 0 as number of confirmations
                  return trx.blockNumber === null ? 0 : currentBlock - trx.blockNumber
                }
                catch (error) {
                  //console.log(error)
                }
              }
        
            function confirmEtherTransaction(txHash, confirmations = 1) {
                setTimeout(async () => {
                  
                  // Get current number of confirmations and compare it with sought-for value
                  const trxConfirmations = await getConfirmations(txHash)
                  
                 //console.log('Transaction with hash ' + txHash + ' has ' + trxConfirmations + ' confirmation(s)')
              
                  if (trxConfirmations >= confirmations) {
                    // Handle confirmation event according to your business logic
                    
                   // console.log('Transaction with hash ' + txHash + ' has been successfully confirmed')
                    storebiddata(txHash);
                  }
                  // Recursive call
                  return confirmEtherTransaction(txHash, confirmations)
                }, 30 * 500)
              } 

            async function storebiddata(bidResult) {
        
                db.collection('bids').add({
                    TxId : bidResult,
                    nftid : NFTData.id,
                    uid : firebase.auth().currentUser.uid,
                    email : firebase.auth().currentUser.email,
                    walletaddress : walletAddress,
                    bidprice : document.getElementById('updated_value').value,
                    tokenid : NFTData.TokenID,
                    timestamp : new Date(),
                    nft : NFTData,
                })
                .then(function(docRef) {
                   // console.log("Document written in bids");
                })
                .catch(function(error) {
                   // console.error("Error adding document in bids");
                }
                );
                const spbbidupdate = firebase.firestore().collection ('NFTs');
                spbbidupdate
                .doc('fkUnfpB5zG2HhnvhmIcP')
                .update({
                    NFTUpdatedPrice : document.getElementById('updated_value').value,
                }).then(
                    () => {
                        // console.log("Document updated")
                        setNotification();
                         const closeLoading = !popupState
                         loadingPopup(closeLoading);
                         window.location.href = "/profile";
                    })
                .catch((error) => console.error("Error updating bid value in db", error));
            }
    function handlePopup(){
        document.querySelector(".lottery-pop-container").classList.add("popup-active");
    }
    function popupClose(){
        document.querySelector(".lottery-pop-container").classList.remove("popup-active");
    }
    function setNotification() {
        const uid = getAuth().currentUser.uid;
        const idCharacters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let _id = ' ';
        const charactersLength = idCharacters.length;
        for ( let i = 0; i < 20; i++ ) {
            _id += idCharacters.charAt(Math.floor(Math.random() * charactersLength));
        }
        const dateObj = new Date();
        const month = dateObj.toLocaleString('default', { month: 'long' });
        
        const notificationRef = firebase.firestore().collection("notifications").doc(_id).set(
            {
                _id : _id,
                date : `${dateObj.getDate()} ${month}, ${dateObj.getFullYear()}`,
                read : false,
                tag : "NFT-purchase",
                text : `You have successfully bid on ${NFTData.nft_title} NFT`,
                time : new Date().getTime(),
                title : "Non-Fungible SPB Bid",
                uid : uid,
            })
        .then(function(docRef) {
            console.log("Notification Document updated");
        })
        .catch(function(error) {
            console.error("Error adding notification: ", error);
        }
        );
        
    }


    return(
        
    <div>
        <div className="spinner">
            <span>Processing...</span>
            <div className="spinner-over half-spinner"></div>
        </div>

             {/* Pop Up Code */}
            
             <div className="lottery-pop-container">
                <div className='lottery-pop-card' style={{height: '500px'}}>
                    <div className="lottery-pop-close"><span  onClick={popupClose}>X</span></div>
                    <h3>Place a bid</h3>
                    <p>You're about to place bid</p>
                    <div className="row">
                        <div class="col-md-12">
                            <p>Latest Bid Value : {NFTData.NFTUpdatedPrice} ETH</p>
                            <p>Enter the price in ETH</p>
                            <input type="text" id="updated_value" className="bid-value" style={{color: 'white'}}/>
                        </div>
                    </div>  
                    <div className="row" style={{paddingTop: '10px'}}>
                        <div className="col-md-12">
                        <div className="wallet-selector-dropdown">
                                <span>Place Bid</span>
                                <div className="wallet-selector-dropdown-content">
                                    <p onClick ={()=>checkBidValue('walletconnect')} className="wallet-select-item">Wallet Connect</p> 
                                    <p onClick ={()=>checkBidValue('metamask')} className="wallet-select-item">Metamask</p>
                                    </div>
                            </div>
                        </div>
                    </div>                 
                </div>
            </div>
                <div id='spb-audio' className="container-fluid">
                  <div className="row" >
                      <div style={{backgroundColor:'black'}} className="nft-final-video">
                        <center> 
                        <iframe
                        loading="lazy" 
                        src='https://iframe.mediadelivery.net/embed/32533/92252619-16b9-4d2d-a4df-d21175a49b68?autoplay=true&loop=true'
                          className="nft-video"
                         frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen></iframe>
                         </center>
                         <div className="vdo-btnn-full">
                           <button  className="vdo-btnn" >
                             <span className="glyphicon glyphicon-heart-empty"></span> Like
                             </button>
                             <button  className="vdo-btnn2">
                               <span className="glyphicon glyphicon-share"></span> 
                               <ShareButton buttonStyle={divStyle}/> </button>
                               </div>
                            </div>
                       <div>
                    </div>
                  </div>
              </div>
      <div className='spbdrop-details'>
              <div className="Loran-title-full">
                  <div className="">
                      <div className="set-1">
      
                          <div className="loran-left">
                              <h1 className="loran-ti spbdetails-txt">VISHWAROOPA DARISANAM</h1>
                              <button className="rounded-pill spb-legendary" id="legentry">Legendary</button>
      
                              <br></br>
                              <br></br>
      
                              <h2 className="spbdetails-txt disc">DESCRIPTION</h2>
                              <div className="spbdetails-txt lorem-para">
                                  <p>
                                  This NFT of Shri S.P. Balasubramaniam’s last song aims to preserve his legacy on the blockchain. 
                                  The highest bidder gets to exclusively unlock 30 minutes of the late musical legend’s masterpiece along with 51% copyright through the NFT!
                                  </p>
                              </div>
                          </div>
      
                      </div>
                      <div className="set-1">
                          <div style={{top: '0px'}} className="loran-right">                       
                              <div style={{border: '2px solid #0000164D'}} className="tabb-box">
                                  <div className="current-bid">
                                      <div className="current-bid-text-1">
      
                                          <h3 style={{textAlign: 'left', fontSize:'20px'}}  className="spbdetails-txt current-bid-text-heading">Current Bid</h3>
                                          <h1 style={{fontSize:'50px', lineHeight:'42px'}} className="spbdetails-txt current-bid-price">{NFTData.NFTUpdatedPrice} ETH</h1>
                                          <h5 className="spbdetails-txt current-bid-price-small">Reserve Price $ 150,000</h5>
                                      </div>
                                  </div>
                                  <div className="final-verti-line-spb"></div>
                                  <div>
      
                                  <div style={{bottom:'278px', left:'284px'}} className="current-bid2">
                                      <div className="current-bid-text-1">
                                          <h3 style={{textAlign: 'left', fontSize:'20px'}}  className="spbdetails-txt current-bid-text-heading">Auction ended</h3>
                                          <h1
                                           style={{fontSize:'42px', lineHeight:'42px'}}
                                             className="spbdetails-txt current-bid-price">-- -- --</h1>
                                          <h5 className="spbdetails-txt date-time">  Days     Hours      Mins Secs</h5>
                                      </div>
                                      </div>
      
                                  </div>
                                  <div className="final-box-hr-spb"></div>
                     <button className="bbn632-hover bn28"   id="place-a-bid">AUCTION ENDED</button>       
                              </div> 
                              <div style={{border: '1px solid #0000164D'}} className="purchase-box">
                                <div style={{borderBottom: '1px solid #0000164D'}}>
                                <h3 className="spbdetails-txt current-bid-text-heading">Current bid</h3>
                                <h1 className="spbdetails-txt current-bid-price">{NFTData.NFTUpdatedPrice} ETH</h1>
                                <h5 className="spbdetails-txt current-bid-price-small">Reserve Price $ 150,000</h5>
                                </div>
                                <div style={{borderBottom: '1px solid #0000164D'}}>
                                <h3  className="spbdetails-txt current-bid-text-heading">Auction ended</h3>
                                <h1   className="spbdetails-txt current-bid-price">-- -- --</h1>
                                <h5 className="spbdetails-txt date-time">  Days      Hours      Mins    Secs</h5>
                                </div>
                                <div>
                                <button className="bbn632-hover bn28"   id="place-a-bid">AUCTION ENDED</button>
                                </div>
                                </div>                        
      
                              <div className="exclusive">
                              <div className="rewards-dropdown">
  <button style={{background: '#000016 0% 0% no-repeat padding-box', color:'#fff'}} className="exclusive-bt spb-exclusive-bt">EXCLUSIVE REWARDS AVAILABLE  <span class="glyphicon glyphicon-menu-down" aria-hidden="true" id="drop-down"></span> </button>
  <div className="dropdown-content" style={{'borderRadius':'50px'}}>
    <center> 
  <h4 style={{ color: 'white' }}>{NFTData.exclusive1}</h4>
  <h4 style={{ color: 'white' }}>{NFTData.exclusive2}</h4>
  </center>
  </div>
</div>  
                              </div>
      
      
      
                          </div>
                      </div>
                  </div>
                  <br></br>
                  <br></br>  <br></br>
                  <br></br>
                  <br></br>  <br></br>
      
                  {/* DETAILS */}
      
                  <div className="final-details">
                      <div>
                          <p className="spbdetails-txt disc">DETAILS</p>
      
                          <div style={{border: '2px solid #0000164D'}} className="final-boxx">
                              <p className="spbdetails-txt ctnt"> 1 of 1 NFTs remaining</p>
                          </div>
                          <br></br>
                          <div style={{border: '2px solid #0000164D'}} className="final-boxx">
                              <p className="spbdetails-txt ctnt1">Blockchain <span style={{color:'#00001680'}} className="content-shad">Ethereum</span> </p>
                          </div>
      
      
                      </div>
      
                      <div className="final-properties-full" >
                          <div className="final-properties">
                              <p className="spbdetails-txt final-properties-head">PROPERTIES</p>
                          </div>
                          <div></div>
                          <div className="final-properties-boxx">
                              <div className="final-properties-box">
                                  <p style={{lineHeight:'32px'}} className=" final-properties-box-text">Category</p>
                                  <p className="spbdetails-txt final-properties-box-text1">{NFTData.Category}</p>
      
                              </div>
      
                              <div className="final-properties-box">
                                  <p style={{lineHeight:'32px'}} className="final-properties-box-text-framerate">Duration</p>
                                  <p className="spbdetails-txt final-properties-box-text1-24">{NFTData.Duration}</p>
      
                              </div>
      
                              <div className="final-properties-box">
                                  <p style={{lineHeight:'32px'}} className="final-properties-box-text-framerate">Content Partner</p>
                                  <p className="spbdetails-txt final-properties-box-text1-24">{NFTData.Content_Partner}</p>
      
                              </div>
      
                              <div className="final-properties-box">
                                  <p style={{lineHeight:'32px'}} className="final-properties-box-text-framerate">Celebrity</p>
                                  <p className="spbdetails-txt final-properties-box-text1-purple">{NFTData.Celebrity}</p>
      
                              </div>
      
                              <div className="final-properties-box">
                                  <p style={{lineHeight:'32px'}} className="final-properties-box-text">Rarity</p>
                                  <p className="spbdetails-txt final-properties-box-text1">{NFTData.rarity}</p>
      
                              </div>
      
                          </div>
      
                      </div>
                     
                  </div>
      
              </div>
      
              <div className="creater-pg-full">
                  <div className="creaters">
                      <h1 style={{color:'#6B6B6B'}} className="creaters-heading">CREATOR</h1>
                      <img src={symphony} className="o-p-img" alt="Logo" />
                     {/* <img className="o-right" alt="Logo" /> */}
                      <h2 className="spbdetails-txt creater-avm">Symphony Recording Co.</h2>
                      <p className="spbdetails-txt creater-royalty">10% Royalties</p>
      
                  </div>
      
                  <div className="final-collection">
                      <h1 style={{color:'#6B6B6B'}} className="creaters-heading">COLLECTION</h1>
                      <img src={creatorimg} className="o-p-img"  alt="Logo" />
                      {/*<img className="o-right" alt="Logo" />*/}
                      <h2 className="spbdetails-txt creater-avm">{NFTData.nft_title}</h2>
                      <p className="spbdetails-txt creater-royalty">{NFTData.rarity}</p>
      
                  </div>
      
                  <div style={{opacity: '0.5'}} className="final-view-prof">
                      <a href="" target="_blank"><p className="final-view-prof-text">VIEW PROOF OF AUTHENTICITY <span className="glyphicon glyphicon-edit"></span></p>
                    </a>
      
                  </div>
      
                  <div className="final-about-avm">
                      <p className="spbdetails-txt final-about-avm-head">ABOUT {NFTData.production_house}</p>
      
                      <div >
                          <p style={{padding:'40px 0 0 0'}} className="spbdetails-txt final-about-avm-para">
                          {NFTData.about}
                          </p>
                      </div>
      
                  </div>
      
                  <div className="final-sales-history final-sales-history-spb">
                  <Tabs direction='ltr'>
    <TabList className='spbdropdetail-tab-ul'>
      <Tab className='spbdropdetail-tab' >BID HISTORY</Tab>
     {/* <Tab className='spbdropdetail-tab' >OWNER HISTORY</Tab> */}
    </TabList>
    <TabPanel>
        <div style={{marginTop:'10px'}}>
            {bidHistory.map((item)=>{
                return(
                <div className="final-sales-box" >
                <img src={avatar} className="final-sale-img" >
                </img>
                <div className="final-sales-username-content" style={{maxHeight:'100px'}}>
                    <div className='walletaddress-history'>
                        <a target='_blank' href={`https://etherscan.io/tx/${item.TxId}`}>
                            <p className="final-about-avm-head">{item.TxId}</p>
                        </a>
                    </div>
                    <p style={{color: 'white'}}><a target="_blank"></a></p>
                    <div style={{top:'10px'}} className="final-sales-username-content2">
                        <p  className="final-about-avm-head">{item.bidprice} ETH</p>
                        </div>
                        </div>
                        </div>
            )
            })}
             
                        </div>
    </TabPanel>
    {/*<TabPanel>
    <div style={{marginTop:'10px'}}>
            <div className="final-sales-box" >
                <div className="final-sale-img" >
                </div>
                <div className="final-sales-username-content" style={{maxHeight:'100px'}}>
                    <p className="final-about-avm-head">Wallet Address2</p>
                    <p style={{color: 'white'}}><a target="_blank"></a>September 28th, 2021</p>
                    <div style={{top:'10px'}} className="final-sales-username-content2">
                        <p style={{top:'10px'}} className="final-about-avm-head">MATIC</p>
                        </div>
                        </div>
                        </div> 
                        </div>
        </TabPanel>*/}
  </Tabs>

      
                 
          

            
      
      
                  </div>
              </div>
      
             
              <div>
      
                  <div style={{paddingBottom:'60px'}} className="final-more-nft-full">
      
                      <h1 className="spbdetails-txt thead">MORE NFTS YOU MIGHT LIKE</h1>
      
                      <Top_selling_products />
      
                  </div>
              </div>
</div>
         
      
             <Fotter />
        </div>


    )
    
}

export default SPBDrop;